export const windowMinuteOptions = [
  { value: '1', label: '1 minute' },
  { value: '2', label: '2 minutes' },
  { value: '3', label: '3 minutes' },
  { value: '4', label: '4 minutes' },
  { value: '5', label: '5 minutes' },
  { value: '10', label: '10 minutes' },
  { value: '15', label: '15 minutes' },
  { value: '20', label: '20 minutes' },
  { value: '25', label: '25 minutes' },
  { value: '30', label: '30 minutes' },
  { value: '60', label: '1 hour' },
  { value: '120', label: '2 hours' },
  { value: '240', label: '4 hours' },
  { value: '480', label: '8 hours' },
  { value: '720', label: '12 hours' },
  { value: '1440', label: '24 hours' },
  { value: '2880', label: '48 hours' },
  { value: '4320', label: '72 hours' },
];

// half-hour increments of minute-of-day; 1440 is the exclusive end of the day, which merchants
// read as 11:59PM. Only valid as an end, so the two selects get different slices of this.
const timeOfDayOptions = Array.from({ length: 49 }, (_, i) => {
  const minuteOfDay = i * 30;
  const hour = Math.floor(minuteOfDay / 60);
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  const paddedMinute = `${minuteOfDay % 60}`.padStart(2, '0');

  return {
    value: `${minuteOfDay}`,
    label:
      minuteOfDay === 1440
        ? '11:59PM'
        : `${displayHour}:${paddedMinute}${hour < 12 ? 'AM' : 'PM'}`,
  };
});

export const startTimeOfDayOptions = timeOfDayOptions.slice(0, -1);

export const endTimeOfDayOptions = timeOfDayOptions.slice(1);

export const timezoneOptions = Intl.supportedValuesOf('timeZone').map(
  (value) => ({ value, label: value.replace(/_/g, ' ') }),
);

export const dayOfWeekOptions = [
  { value: '0', label: 'Sunday', keywords: ['Sun'] },
  { value: '1', label: 'Monday', keywords: ['Mon'] },
  { value: '2', label: 'Tuesday', keywords: ['Tue'] },
  { value: '3', label: 'Wednesday', keywords: ['Wed'] },
  { value: '4', label: 'Thursday', keywords: ['Thu'] },
  { value: '5', label: 'Friday', keywords: ['Fri'] },
  { value: '6', label: 'Saturday', keywords: ['Sat'] },
];

const optionLabel = (
  options: { value: string; label: string }[],
  value: number,
) => options.find((o) => o.value === `${value}`)?.label ?? `${value}`;

export const overrideSummary = {
  days: (daysOfWeek: number[]) => {
    if (daysOfWeek.length === 7) return 'Every day';

    return [...daysOfWeek]
      .sort((a, b) => a - b)
      .map((d) => dayOfWeekOptions[d]?.keywords[0] ?? `${d}`)
      .join(', ');
  },
  dayNames: (daysOfWeek: number[]) =>
    [...daysOfWeek]
      .sort((a, b) => a - b)
      .map((d) => optionLabel(dayOfWeekOptions, d))
      .join(', '),
  timeRange: (startMinuteOfDay: number, endMinuteOfDay: number) =>
    `${optionLabel(timeOfDayOptions, startMinuteOfDay)} - ${optionLabel(timeOfDayOptions, endMinuteOfDay)}`,
  window: (windowMinutes: number) =>
    optionLabel(windowMinuteOptions, windowMinutes),
};
